export const capitalizeFirstLetter = (text: string) => {
  return text && text[0].toUpperCase() + text.slice(1);
};